import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'intercection-count');
export const actions = createActions(consts);

const daysParams = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
].map(day => ({
  type: 'payload.query',
  queryParameter: day,
  selector: day,
}));

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'provider',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'calendar',
    'schedule',
    'intersection_ids',
    {
      type: 'payload.query',
      queryParameter: 'start_on',
      selector: 'startOn',
    },
    {
      type: 'payload.query',
      queryParameter: 'end_on',
      selector: 'endOn',
    },
    {
      type: 'payload.query',
      queryParameter: 'start_time',
      selector: 'startTime',
    },
    {
      type: 'payload.query',
      queryParameter: 'end_time',
      selector: 'endTime',
    },
    ...daysParams,
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/intersection-counts-req.js